/* eslint-disable react/prop-types */
import { Dropdown } from 'react-bootstrap';

type EditAction = () => void;
type PaymentAction = () => void;
type ViewInvoiceAction = () => void;

interface ActionDropdownItemsProps {
  editAction?: EditAction; // Make the prop optional
  paymentDetail?: PaymentAction;
  viewInvoice?: ViewInvoiceAction;
}

const SupplierDropdownItems: React.FC<ActionDropdownItemsProps> = ({
  editAction = () => {},
  paymentDetail = () => {},
  viewInvoice = () => {}
}) => {
  return (
    <>
      <Dropdown.Item eventKey="1" onClick={editAction}>
        Edit
      </Dropdown.Item>
      {/* <Dropdown.Item eventKey="2">Export</Dropdown.Item> */}
      <Dropdown.Divider />
      <Dropdown.Item
        eventKey="2"
        className="text-success"
        onClick={paymentDetail}
      >
        Print Receipt
      </Dropdown.Item>
      {/* <Dropdown.Divider />
      <Dropdown.Item eventKey="2" className="text-info" onClick={viewInvoice}>
        View Invoice Detail
      </Dropdown.Item> */}
    </>
  );
};

export default SupplierDropdownItems;
